export let Type = ["U8", "I8", "U16", "I16", "U32", "I32", "F0", "F1", "F2", "F3", "F6", "FE"];

export function GetIncrementDecrementGain(type) {
  if (type == Type[7]) {
    return 0.1;
  } else if (type == Type[8]) {
    return 0.01;
  } else if (type == Type[9]) {
    return 0.001;
  } else if (type == Type[10]) {
    return 0.000001;
  } else {
    return 1;
  }
}

/**
 * GetTypeByteSize - Return number of byte required for given type
 * @param {type} - Input type
 * @return {value} - Number of byte
 **/
export function GetTypeByteSize(type) {
  if (type == Type[0] || type == Type[1]) {
    return 1;
  } else if (type == Type[2] || type == Type[3]) {
    return 2;
  } else {
    return 4;
  }
}

/**
 * IsTypeFloat - Return true if input type is float type, otherwise false
 * @param {type} - Input type
 * @return {boolean} - True / False
 **/
export function IsTypeFloat(type) {
  if (type == Type[6] || type == Type[7] || type == Type[8] || type == Type[9] || type == Type[10] || type == Type[11]) {
    return true;
  } else {
    return false;
  }
}

/**
 * IsTypeInteger - Return true if input type is integer type, otherwise false
 * @param {type} - Input type
 * @return {boolean} - True / False
 **/
export function IsTypeInteger(type) {
  if (type == Type[0] || type == Type[1] || type == Type[2] || type == Type[3] || type == Type[4] || type == Type[5]) {
    return true;
  } else {
    return false;
  }
}

/**
 * GetTypeValue - Return code for given input type as hexa value with 2 fixed places
 * @param {type} - Input type
 * @return {result} - Type code
 **/
export function GetTypeValue(type) {
  let typeValue = 0;

  switch (type) {
    case "I8":
    case "U8":
      typeValue = 1;
      break;
    case "I16":
    case "U16":
      typeValue = 3;
      break;
    case "I32":
    case "U32":
      typeValue = 5;
      break;
    case "F0":
      typeValue = 40;
      break;
    case "F1":
      typeValue = 41;
      break;
    case "F2":
      typeValue = 42;
      break;
    case "F3":
      typeValue = 43;
      break;
    case "F6":
      typeValue = 46;
      break;
    case "FE":
      typeValue = 50;
      break;

    default:
      typeValue = 0;
      break;
  }

  typeValue = typeValue.toString(16).toUpperCase();

  if (typeValue.length == 1) {
    typeValue = "0" + typeValue;
  }

  return typeValue;
}
